<template>
  <div :class="['header-wrapper row m-0', { 'is-fleet-header': isFleetPartnerOnly }]">
    <SearchBar />
    <!-- <Logo/> -->
    <div class="d-flex p-0 align-items-center">
      <IconButton
        v-if="!isToggleSidebar"
        @click="toggleSidebar"
        title="Toggle Sidebar"
        class="me-2"
        :invert-color="isFleetPartnerOnly"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="9" x2="9" y1="21" y2="3" />
        </svg>
      </IconButton>
      <div class="left-header p-0 flex-grow-1 overflow-hidden">
      <WelcomeMessage />
      </div>
      <div class="nav-right pull-right right-header p-0 flex-shrink-0 ms-auto">
        <ul class="nav-menus">
          <li class="language-nav">
            <LanguageHeader :invert-color="isFleetPartnerOnly" />
          </li>
          <li v-if="showSitemap">
            <IconButton to="/sitemap" title="Portal Sitemap" :invert-color="isFleetPartnerOnly">
              <svg
                width="20"
                height="20"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <g>
                  <path
                    fill="currentColor"
                    d="M472,328H448V264a24.027,24.027,0,0,0-24-24H272V176h32a24.028,24.028,0,0,0,24-24V80a24.028,24.028,0,0,0-24-24H208a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h32v64H88a24.027,24.027,0,0,0-24,24v64H40a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h80a24.028,24.028,0,0,0,24-24V352a24.028,24.028,0,0,0-24-24H96V272H240v56H216a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h80a24.028,24.028,0,0,0,24-24V352a24.028,24.028,0,0,0-24-24H272V272H416v56H392a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h80a24.028,24.028,0,0,0,24-24V352A24.028,24.028,0,0,0,472,328ZM216,88h80v56H216ZM112,360v56H48V360Zm176,0v56H224V360Zm176,56H400V360h64Z"
                  ></path>
                </g>
              </svg>
            </IconButton>
          </li>
          <li>
            <BookmarkDropdown :invert-color="isFleetPartnerOnly" />
          </li>
          <li>
            <IconButton title="Search (Ctrl/⌘+K)" @click="searchOpen" :invert-color="isFleetPartnerOnly">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11 6C13.7614 6 16 8.23858 16 11M16.6588 16.6549L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                />
              </svg>
            </IconButton>
          </li>
          <AlertBell v-if="showFleetAlerts" :invert-color="isFleetPartnerOnly" />
          <Profile :invert-color="isFleetPartnerOnly" />
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import LanguageHeader from './LanguageHeader/index.vue';
import AlertBell from './AlertBell/index.vue';
import Profile from './profile.vue';
import SearchBar from './search.vue';
import BookmarkDropdown from './BookmarkDropdown.vue';
import IconButton from '@/components/common/IconButton.vue';
import WelcomeMessage from './WelcomeMessage.vue';
import { getUserAddDataFromLocalStorage } from '@/utils/userUtils';
import { PARTNER_TYPES } from '@/constants/partner-types';
import { usePartnerType } from '@/composables/common';

const store = useStore();
const { isFleetPartnerOnly } = usePartnerType();

const isToggleSidebar = computed(() => store.state.menu.togglesidebar);

const showSitemap = computed(() => {
  try {
    const { partnerTypes } = getUserAddDataFromLocalStorage();
    return (
      partnerTypes?.some((type) =>
        [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER].includes(type)
      ) ?? false
    );
  } catch {
    return false;
  }
});

const showFleetAlerts = computed(() => true);

function searchOpen() {
  store.state.menu.searchOpen = true;
}

function toggleSidebar() {
  store.dispatch('menu/opensidebar');
}
</script>

<style lang="scss">
@import '@/assets/scss/utils/_variables.scss';

.is-fleet-header {
  background-color: $primary-color;

  & > p,
  & > span {
    color: #fff !important;
  }
}
</style>
